import { render, staticRenderFns } from "./plan-layout-next-buttons.vue?vue&type=template&id=64f55131"
import script from "./plan-layout-next-buttons.js?vue&type=script&lang=js&external"
export * from "./plan-layout-next-buttons.js?vue&type=script&lang=js&external"
import style0 from "./plan-layout-next-buttons.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports